const validateForm = (values) => {
  const errors = {};

  if (!values.deliveryId) {
    errors.deliveryId = { message: 'error1' };
  } else if (values.deliveryId.length > 11) {
    errors.deliveryId = { message: 'error2' };
  } else if (!/^(?:d|o|r)\d+$/i.test(values.deliveryId)) {
    errors.deliveryId = { message: 'error3' };
  }

  if (!values.mobileNo) {
    errors.mobileNo = { message: 'mobileNo' };
  }

  return errors;
};

export default validateForm;
